import { Stack, Typography, Box } from '@mui/material';
import ScoreBox from './scoreBox';
import ColorDot from '../colorDot';
import EmojiOutcomeBox from './emojiOutcomeBox';
import ColorLine from '../colorDot/colorLine';
import { useSelector } from 'react-redux';

const TeamSetFinalScore = ({ team, game }) => {
  const useTeamName = team.name !== 'Team 1' && team.name !== 'Team 2' && team.name;

  const selectedEvent = useSelector((state) => state.event.event);

  const teamName = useTeamName
    ? team.name
    : team.players
        .map((player) => {
          if (team.players.length > 2) {
            return player.split(' ')[0].charAt(0) + '. ' + player.split(' ')[1];
          } else {
            return player;
          }
        })
        .join(', ');

  const getGroupNameFromEvent = (teamGroupId) => {
    if (!selectedEvent || !selectedEvent.teamGroups) return null;
    const group = selectedEvent.teamGroups.find((g) => g.id === teamGroupId);
    return group ? group.name : null;
  };

  return (
    <Box
      display="flex"
      flexDirection={'column'}
      alignItems="center"
      sx={{ minWidth: 0, maxWidth: '100%' }}>
      <ColorLine color={team.color} />
      <Stack
        px={{ xs: 0.5, sm: 3 }}
        alignItems={'center'}
        justifyContent={'center'}
        sx={{ minWidth: 0, maxWidth: '100%' }}>
        <Typography variant="caption" textAlign="center" sx={{ overflowWrap: 'anywhere' }}>
          {teamName}
        </Typography>
        {team.teamGroupId && (
          <Typography
            variant="caption"
            fontSize={'0.6em'}
            color={team.color}
            textAlign="center"
            sx={{ overflowWrap: 'anywhere' }}>
            {getGroupNameFromEvent(team.teamGroupId)}
          </Typography>
        )}
        {game.teamTotals && (
          <EmojiOutcomeBox
            score={game.teamTotals[team.id]}
            emoji={
              game.winningTeamId === team.id ? '🏆' : game.winningTeamId === null ? ' - ' : '🥈'
            }
          />
        )}
      </Stack>
    </Box>
  );
};

export default TeamSetFinalScore;
